export default {
  common: {
    nav: {
      home: "Trang chủ",
      find_offer_help: "Tìm / Trao giúp đỡ",
      celebrate: "Tôn vinh một cuộc đời",
      family_tree: "Cây gia phả",
      events: "Sự kiện",
      civic_reports: "Báo cáo dân sự",
      neighborhood_pulse: "Nhịp đập khu phố",
      weather: "Thời tiết",
      nature: "Thiên nhiên",
      marketplace: "Chợ",
      news: "Tin tức",
      causes: "Nguyên nhân",
      more: "Thêm",
    },
    header: { sign_in: "Đăng nhập", join: "Tham gia Social Pulse", language: "Ngôn ngữ", search: "Tìm kiếm" },
    tagline: "Kết nối cộng đồng · Trao quyền cuộc sống · Xây dựng vốn xã hội",
    locality: { viewing_from: "Bạn đang xem từ", change: "Thay đổi", set_your_location: "Đặt vị trí của bạn" },
    news: { title: "Bản tin hàng ngày của bạn.", play_briefing: "Phát bản tin hàng ngày", listen: "Nghe", translate: "Dịch" },
  },
};
